<template>
  <div>
      <div id="convert-error" class="row col-lg-4 col-md-6 col-12 alert alert-primary shadow-lg" role="alert">
          <div class="container">
              <div class="text-center">
                  <div>
                    <span class="conver-error-title">Sorry</span><i class="far fa-frown"></i>
                  </div>
                  <div class="conver-error-text">{{error && Object.keys(error).includes('message') ? error.message :'Something went wrong... Please try again later'}}</div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
    name: 'ErrorBlock',
    props: {
        error: Object | Boolean,
    },
}
</script>
<style scoped>
.conver-error-action-text {
  color: #ff5916;
}
</style>
